import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { BootstrapProvider } from './context/BootstrapContext.jsx';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No se encontró el contenedor raíz para React');
}

const root = createRoot(rootElement);
root.render(
  <BootstrapProvider>
    <App />
  </BootstrapProvider>
);
